import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getPatientQuestionnaire } from "../../Redux/Actions/patients";
import useLocalQuery, { Table } from "hooks/useQuery/local-query";
import PatientQuestionnaireResults from "./patient-questionnaire-results";
import PureModal from "components/ui/modal/pure-modal";
import EditLink from "components/ui/edit-link";
import moment from "moment";

const PatientQuestionnaires = ({
  patientId,
  Questionnaire,
  getPatientQuestionnaire
}) => {
  React.useEffect(() => {
    getPatientQuestionnaire(patientId);
  }, []);
  const { rows, query, queryDispatcher, count } = useLocalQuery(Questionnaire, {
    sort: { by: "questionnaire_date", direction: "asc" },
    filters: {},
    pagination: { page: 1, per: 100 }
  });
  return (
    <Table
      containerClass="query-table"
      rowKey="questionnaire_assignment_id"
      isFetching={false}
      columns={[
        {
          header: "Patient",
          field: "patient_name"
        },
        {
          header: "Title",
          field: "title"
        },
        {
          header: "Product",
          field: "product_name"
        },
        {
          header: "Description",
          field: "description"
        },
        {
          header: "Type",
          field: "questionnaire_type"
        },
        {
          header: "Assigned Date",
          field: "questionnaire_date"
        },
        {
          header: "Response Date",
          field: "responded_date"
        },
        {
          field: "",
          header: " "
        }
      ]}
      rows={rows}
      query={query}
      count={count}
      queryDispatcher={queryDispatcher}
      TableRow={({
        patient_name,
        patient_id,
        title,
        product_name,
        description,
        questionnaire_type,
        questionnaire_date,
        questionnaire_assignment_id,
        responded_date
      }) => (
        <tr>
          <td>{patient_name}</td>
          <td>{title}</td>
          <td>{product_name}</td>
          <td>{description}</td>
          <td>{questionnaire_type === "1" ? "Product" : "Service"}</td>
          <td>{moment(questionnaire_date).format("L")}</td>
          <td>{responded_date ? moment(responded_date).format("L") : ""}</td>
          <td>
            <span
              style={{
                display: "grid",
                gridTemplateColumns: "70px 70px",
                gridGap: 10
              }}
            >
              {responded_date && (
                <PureModal
                  renderTrigger={({ openModal }) => (
                    <EditLink
                      onClick={() => {
                        openModal();
                      }}
                      showIcon={false}
                      text="View"
                    />
                  )}
                  windowProps={{ large: true }}
                >
                  <PatientQuestionnaireResults
                    patient_id={patient_id}
                    questionnaire_assignment_id={questionnaire_assignment_id}
                  />
                </PureModal>
              )}
            </span>
          </td>
        </tr>
      )}
    />
  );
};

PatientQuestionnaires.propTypes = {
  patientId: PropTypes.string.isRequired,
  Questionnaire: PropTypes.arrayOf(PropTypes.object),
  getPatientQuestionnaire: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default connect(
  state => ({
    Questionnaire: state.getIn(["newRootReducer"]).rdc_patients.Questionnaire
  }),
  {
    getPatientQuestionnaire
  }
)(PatientQuestionnaires);
